import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';

import Header from '../containers/HeaderContainer';
import Schedule from '../containers/SchedulerContainer';

import logoKMIAC from "../kmiac-logo-103x92.png";
import {getSchedule} from "../requests";

const mobile = window.innerWidth < 720;

class App extends Component {
    componentWillMount() {
        !this.props.organizationCode && this.props.setOrganization({organizationCode: '240013'});
        this.upateTimer = setInterval(() =>
            getSchedule({
                organization: !!this.props.organizationCode ? this.props.organizationCode : '240013',
                deep: this.props.days,
                setSchedule: this.props.setSchedule,
                setTSesList: this.props.setTSesList,
                setOrganizationList: this.props.setOrganizationList}), 10000
        );
    }

    componentDidMount() {
        setTimeout(() =>
            getSchedule({
                organization: !!this.props.organizationCode ? this.props.organizationCode : '240013',
                deep: this.props.days,
                setSchedule: this.props.setSchedule,
                setTSesList: this.props.setTSesList,
                setOrganizationList: this.props.setOrganizationList}), 100
        );
    }

    componentWillUnmount() {
        clearInterval(this.upateTimer)
    }

    render() {
        const {
            days,
            schedule,
            schedulePersonal,
            tSes,
            organization,
            organizationCode,
            setSchedule,
            setTSesList,
            setOrganizationList,
        } = this.props;
        //getSchedule({organization: organizationCode, deep: days, setSchedule: setSchedule, setTSesList: setTSesList, setOrganizationList: setOrganizationList});

        return (
            <div className="Schedule" style={{width: '100vw'}}>
                <Header />
                <img
                    src={logoKMIAC}
                    style={{
                        position: 'absolute',
                        right: '5%',
                        width: 60,
                        margin: 20,
                        visibility: 'hidden',
                    }}
                />
                <Typography variant={!mobile ? "headline" : "subheading"} style={{margin: 20, marginBottom: 0, marginLeft: '5%'}}>
                    {this.props.organization}
                </Typography>
                {!mobile ?
                    <div>
                        <Typography variant="subheading" style={{margin: 20, marginBottom: 0, marginTop: 0, marginLeft: '5%'}}>
                            {'Министерством здравоохранения Красноярского края проводится работа по визуализации доступности записи в поликлинику ' + this.props.organizationShortName + '.'}
                        </Typography>
                        <Typography variant="subheading" style={{margin: 20, marginBottom: 0, marginTop: 0, marginLeft: '5%'}}>
                            {'Представлена оперативная информация в он-лайн режиме.'}
                        </Typography>
                        <Typography variant="subheading" style={{margin: 10, marginRight: 20, marginTop: 0, marginLeft: '5%'}}>
                            {'Принимаем ваши предложения по развитию по адресу '}
                            <a href={'mailto:s.chausenko@kmiac.ru'} style={{color:'#000000de'}}>s.chausenko@kmiac.ru</a>
                        </Typography>
                    </div>: null}
                <Schedule />
            </div>
        );
    }
}

export default App;
